import React, { useEffect, useState } from "react";
import { Button, Form, Input } from "rsuite";
import * as loginad from "../../Services/LoginADservice";
import * as loginInfoDB from "../../Services/UsersDB";
import * as userManager from "../../Services/UserSessionManager";
import { publicIpv4 } from "public-ip";
import { Alert } from "react-bootstrap";
type attributes = {
  onLoginSuccess(status: boolean): void;
};

export const Login = (props: attributes) => {
  const [userLogin, setUserLogin] = useState({ username: "" });
  const [loading, setLoading] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const handleInput = (val: any, event: any) => {
    setUserLogin({ ...userLogin, [event.target.name]: val });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await loginad.FusionAuthApiCall();
        if (resp != null) {
          const token = resp.data.access_Token;
          userManager.SetFusionAuthToken(token);
          debugger;
          const response = await loginInfoDB.GetUserLoginInfo(resp.data.Email);
          userManager.SetIDRole(response.data);
          setTimeout(() => {
            props.onLoginSuccess(true);
            setLoading(false);
          }, 250);
        }
      } catch (error) {}
    };
    fetchData();
  }, []);

  const login = async () => {
    try {
      var username: string;

      if (userLogin.username.includes("@starmarkit.com"))
        username = userLogin.username;
      else username = userLogin.username + "@starmarkit.com";

      const url =
        `${process.env.REACT_APP_STEM_FUSIONAUTH}/authorize?` +
        `client_id=${process.env.REACT_APP_STEM_CLIENTID}` +
        `&response_type=code` +
        `&redirect_uri=${process.env.REACT_APP_STEM_API_BASE_URL}/api%2Foauth-callback` +
        `&scope=offline_access` +
        `&login_hint=${username}`;

      const ipaddress = await publicIpv4();

      const response = await loginInfoDB.IpUserLogin(username, ipaddress);

      if (response.data === true) {
        window.location.href = url;

        const userLoginInfoResponse = await loginInfoDB.GetUserLoginInfo(
          username
        );
        userManager.SetIDRole(userLoginInfoResponse.data[0].EmployeeDetails);

        setTimeout(() => {
          props.onLoginSuccess(true);
          setLoading(false);
        });
      } else {
        setShowMessage(true);
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  return (
    <>
      {showMessage && (
        <Alert
          variant="danger"
          onClose={() => setShowMessage(false)}
          dismissible
        >
          <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
          <p>
            You cannot access VitalAxis URL from this region. Please share your
            public IP address with our support team. To get the public IP, type
            "What is my IP" in browser. Support Email:{" "}
            <Alert.Link href="mailto:stemssupport@vitalaxis.com">
              mailto:stemssupport@vitalaxis.com
            </Alert.Link>
          </p>
        </Alert>
      )}

      <div className="d-flex flex-column gap-3 screen-h bg-light justify-content-center align-items-center">
        <div className="mb-2">
          <img
            src="stems-logo-inverted.png"
            className="rounded logo-resized"
            alt="Logo"
          />
        </div>
        <div className="w-25">
          <Form.ControlLabel>Email</Form.ControlLabel>
          <Input
            className="form-control"
            type="text"
            placeholder="e.g: John.Smith@starmarkit.com"
            name="username"
            onChange={handleInput}
            onPressEnter={login}
            disabled={loading}
            autoFocus={true}
          />
        </div>

        <div>
          Need Help? contact:{" "}
          <b style={{ cursor: "pointer" }}>
            <a className="mailto" href="mailto:stemssupport@vitalaxis.com">
              stemssupport@vitalaxis.com
            </a>
          </b>
        </div>

        <div>
          <Button
            appearance="default"
            className="stems-primary"
            disabled={loading}
            loading={loading}
            onClick={login}
          >
            Login
          </Button>
        </div>
      </div>
    </>
  );
};
